import Vuex from "vuex";
import Vue from "vue";
import { postRequest } from "../../src/assets/utils/api";
import createPersistedPlugin from "./createPersistedPlugin.js";
const persistedPlugin = createPersistedPlugin();
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    showPay: {},//用来显示支付宝，例如支付要充值然后返回
    payPwdStatus: null,
    wexinke: null,

    formicary: {
      create: {
        photo: "",
        name: null,
        type: null,
        price: null
      },
      newsinfo:{},//newsinfo
      newstype: 'add',//用来记录是发布动态还是编辑动态 add添加动态，edit是编辑动态
      nestInfo: {},
      complaintArr: null,
      antnewinfo: {},
      firstCreate: false,
      needFresh: false,
      switchlist: false, //只看握住
      isShield: false//用来控制是否拉黑了窝主的弹框
    },
    camp:{
      workdetail:{},//这是作业详情
    },
    // 首页消息；
    mess: null,
    addnews: {
      type: "news",//news
      recommend: {},
      nestinfo: {}
    },
    // 设置当前的支付页面
    paypage: {},
    hasUser: localStorage.getItem("user_id")
  },
  mutations: {
    // 添加作业详情内容；
    setWorkDetail(state,data){
      state.camp.workdetail=data;
    },
    setNewsType(state, data) {
      state.formicary.newstype = data;
    },
    setNewsInfo(state,data){
      state.formicary.newsinfo = data;
    },
    setisShield(state, data) {
      state.formicary.isShield = data;
    },
    setUser(state, data) {
      console.log(data)
      state.hasUser = data;
    },
    setPaypage(state, data) {
      state.paypage = data;
    },
    setswitchlist(state, status) {
      state.formicary.switchlist = status;
    },
    setRecommend(state, data) {
      state.addnews.recommend = data;
    },
    setType(state, data) {
      state.addnews.type = data;
    },
    setNestinfo(state, data) {
      state.addnews.nestinfo = data;
    },
    setFresh(state, data) {
      state.formicary.needFresh = data;
    },
    setShowPay(state, status) {
      state.showPay = status;
    },
    setNestFirstCreate(state, data) {
      state.formicary.firstCreate = data;
    },
    setPayPwdStatus(state, data) {
      state.payPwdStatus = data;
    },
    setWeixinke(state, data) {
      state.wexinke = data;
    },
    setNest1(state, data) {
      state.formicary.create.photo = data.photo;
      state.formicary.create.name = data.name;
    },
    setNest2(state, data) {
      state.formicary.create.type = data.type;
      state.formicary.create.price = data.price;
    },

    setmess(state, data) {
      state.mess = data;
    },
    setComplaintArr(state, data) {
      state.formicary.complaintArr = data;
    },
    setAntnewinfo(state, data) {
      state.formicary.antnewinfo = data;
    }
  },
  actions: {
    GetPayPwdStatus({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        postRequest({
          service: "App.UserExt.GetSecurity"
        }).then(res => {
          if (res.data.ret == 200) {
            let data = res.data.data.paypwd;
            // let data=false;
            commit("setPayPwdStatus", data);
            resolve(data);
          }
        });
      });
    },
    getWeixinke({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        postRequest({
          service: "App.Sys.GetWXKFFree",
          client: "wx"
        }).then(res => {
          let weixin = res.data.data.status
            ? res.data.data.status
            : res.data.data;
          commit("setWeixinke", weixin);
          resolve(weixin);
        });
      });
    },
    getMess({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        postRequest({
          service: "App.Sms_Sms.CountNoRead"
        }).then(res => {
          if (res.data.ret == 200) {
            let data = res.data.data;
            // let data=false;
            commit("setmess", data);
            resolve(data);
          }
        });
      });
    }
  },
  getters: {},
  plugins: [persistedPlugin]
});
export default store;
